import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import styles from "./Item.module.scss";
import { Button } from "@mui/material";
import cn from "classnames";
import { useShelvingStore } from "../../store/useShelvingStore";
import { getItemFillingRangesNew } from "../../store/helpers/getItemFillingRangesNew";
import shallow from "zustand/shallow";
import { useStoreSystem } from "../../store";

import { SectionInterface } from "../../store/types/store";
import { isNewSite } from "../../utils";

const Item: FunctionComponent<any> = ({ item, onClick, editSectionId, isBottom, view }) => {
    const { setSectionItemsYPos, addItemToSection, removeSpiritItems, addSpiritItems, colorsItems } = useShelvingStore(
        (state) => ({
            setSectionItemsYPos: state.setSectionItemsYPos,
            addItemToSection: state.addItemToSection,
            removeSpiritItems: state.removeSpiritItems,
            addSpiritItems: state.addSpiritItems,
            colorsItems: state.colorsItems,
        }),
        shallow
    );

    const { sectionFilling, setSystemProperties, setCurrentEditItem } = useStoreSystem(
        (state) => ({
            sectionFilling: state.sectionFilling,
            setSystemProperties: state.setSystemProperties,
            setCurrentEditItem: state.setCurrentEditItem,
        }),
        shallow
    );

    const [holdButton, setHoldButton] = useState<boolean>(false);

    const sections = useShelvingStore((state) => state.getCurrentShelving().sections);
    const isHoldButtonProperty = useStoreSystem((state) => state.sectionFilling.isHoldButton);

    useEffect(() => {
        if (!isHoldButtonProperty) {
            setHoldButton(false);
        }
    }, [isHoldButtonProperty]);

    const addItemHandler = () => {
        if (!isBottom && editSectionId) {
            setSectionItemsYPos(null, editSectionId);
            addItemToSection(item, editSectionId);
        }
        if (isBottom) {
            setCurrentEditItem(undefined, false);
            setSystemProperties([{ name: "sectionFilling", subName: "itemID", value: item.ID }]);
            removeSpiritItems();
            if (holdButton) {
                setSystemProperties([
                    { name: "sectionFilling", subName: "itemID", value: "" },
                    { name: "sectionFilling", subName: "isHoldButton", value: false },
                ]);
                setHoldButton(false);
                return;
            }
            if (sectionFilling.isFilling && !holdButton) {
                setHoldButton(true);
                setSystemProperties([{ name: "sectionFilling", subName: "isHoldButton", value: true }]);
            }
            const sectionsWithoutSpiritItems: SectionInterface[] = sections.map((section) => {
                return { ...section, items: section.items.filter((item) => !item.isSpirit) };
            });
            const ranges = getItemFillingRangesNew({ sections: sectionsWithoutSpiritItems, item });
            if (ranges.length === 0) {
                alert(`Нет доступного места для добавления с учетом ограничений.`);
                setHoldButton(false);
                setSystemProperties([
                    { name: "sectionFilling", subName: "itemID", value: "" },
                    { name: "sectionFilling", subName: "isHoldButton", value: false },
                ]);
            } else {
                addSpiritItems(ranges, item);
            }
        }
    };

    useEffect(() => {
        if ((sectionFilling.itemID !== item.ID || !sectionFilling.isFilling) && !sectionFilling.isHoldButton) {
            setSystemProperties([{ name: "sectionFilling", subName: "isHoldButton", value: false }]);
            setHoldButton(false);
        }
    }, [sectionFilling.isFilling, sectionFilling.itemID]);

    const price = useMemo(() => {
        if (colorsItems.brackets && isNewSite()) {
            return (
                // @ts-ignore
                item?.newNomenkl?.find((n) => n?.color === colorsItems.brackets)?.price ||
                item?.newNomenkl?.[0]?.price ||
                item?.PRICE ||
                0
            );
        }
        return item?.PRICE || 0;
    }, [colorsItems.brackets, item]);

    return (
        <div onClick={onClick} className={cn(styles.container, isBottom && styles.small, styles[view])}>
            <img src={item.PICTURE || `${process.env.PUBLIC_URL}/images/polka.jpg`} />
            <div className={styles.description}>
                <span className={styles.name}>{item.NAME}</span>
                <div className={styles.itemBottom}>
                    <span className={styles.price}>{price}&nbsp;₽</span>
                    <Button
                        className={cn(styles.btn, sectionFilling.isFilling && holdButton && styles.btn_hold)}
                        variant="contained"
                        onClick={addItemHandler}
                    >
                        Добавить
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Item;
